<script lang="ts" setup>
import Group from '~/components/gamescreen/Group.vue'

const { t } = useI18n()

const { tournament } = defineProps<{
  tournament: Tournament
}>()

const { data: groups } = await useApi('/tournaments/{tournament}/groups', {
  path: {
    tournament: tournament.id,
  },
  key: `tournament-groups-${tournament.id}`,
  deep: true,
})

if (groups.value === null || groups.value === undefined) {
  throw new Error('No groups phase.')
}

useSeoMeta({
  title: `${t('Groups')} | ${tournament.name} @ ${tournament.event_name}`,
})

defineOgImageComponent('DartsSpace', {
  title: `${t('Groups')} | ${tournament.name}`,
})

onMounted(() => {
  if (!tournament.complete) {
    window.Echo.private(`tournaments.${tournament.id}`)
      .listen('.App\\Events\\GroupUpdatedEvent', (newData: TournamentGroup) => {
        if (groups.value && groups.value[newData.group_number]) {
          groups.value[newData.group_number] = newData
        }
      })
      .listen('.App\\Events\\GameUpdatedEvent', (newData: Game) => {
        if (groups.value && newData.group && groups.value[newData.group]) {
          const index = groups.value[newData.group]!.games.findIndex(item => item.id === newData.id)
          groups.value[newData.group]!.games[index] = newData
        }
      })
  }
})
</script>

<template>
  <div
    v-if="tournament.phase === 'group' || tournament.phase === 'elimination' || tournament.complete"
    class="grid md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 md:gap-2 self-start w-full"
  >
    <Group
      v-for="(group, id) in groups"
      :key="id"
      :boards="[]"
      :tournament="tournament"
      :group="group"
      :display-only="true"
    />
  </div>
  <div v-else>
    <UiAlert
      variant="warning"
      :title="$t('Group phase has not started')"
    />
  </div>
</template>
